/**
 * AI Analyst copy: the floating launcher and the docked panel.
 * Ported verbatim from VentaHub where it exists (the header's "Ask AI" button
 * and its aria-label); the rest is new with the docked panel.
 * Wired under `aiAnalyst` in `en.ts`.
 */
export const aiAnalystShell = {
  launcher: {
    askAi: 'Ask AI',
    askAiAboutPage: 'Ask AI about this page',
    shortcutMac: '⌘J',
    shortcutOther: 'Ctrl+J',
    busy: 'The AI Analyst is answering',
    done: 'Your answer is ready',
  },
  panel: {
    label: 'AI Analyst',
    title: 'AI Analyst',
    newChat: 'New chat',
    openFullScreen: 'Open full screen',
    close: 'Close',
    history: 'History',
    recentConversations: 'Recent conversations',
    noConversations: 'No conversations yet.',
    viewAll: 'View all conversations',
    resize: 'Resize the AI Analyst panel',
    startHeading: 'Ask about what you are looking at',
    startBody: 'The analyst sees which page you are on and what it shows.',
  },
} as const
